var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#E7E6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.1667V13.5C12 12.6716 12.6716 12 13.5 12H17.1667C17.9951 12 18.6667 12.6716 18.6667 13.5V17.1667C18.6667 17.9951 17.9951 18.6667 17.1667 18.6667H13.5C12.6716 18.6667 12 17.9951 12 17.1667Z",
    stroke: "#605BFF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 26.5002V22.8335C12 22.0051 12.6716 21.3335 13.5 21.3335H17.1667C17.9951 21.3335 18.6667 22.0051 18.6667 22.8335V26.5002C18.6667 27.3286 17.9951 28.0002 17.1667 28.0002H13.5C12.6716 28.0002 12 27.3286 12 26.5002Z",
    stroke: "#605BFF",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.333 17.1667V13.5C21.333 12.6716 22.0046 12 22.833 12H26.4997C27.3281 12 27.9997 12.6716 27.9997 13.5V17.1667C27.9997 17.9951 27.3281 18.6667 26.4997 18.6667H22.833C22.0046 18.6667 21.333 17.9951 21.333 17.1667Z",
    stroke: "#605BFF",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.333 26.5002V22.8335C21.333 22.0051 22.0046 21.3335 22.833 21.3335H26.4997C27.3281 21.3335 27.9997 22.0051 27.9997 22.8335V26.5002C27.9997 27.3286 27.3281 28.0002 26.4997 28.0002H22.833C22.0046 28.0002 21.333 27.3286 21.333 26.5002Z",
    stroke: "#605BFF",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGrid);
export default __webpack_public_path__ + "static/media/IconGrid.aec1feb16bbaddcaac5eeaf2f6b11d9b.svg";
export { ForwardRef as ReactComponent };